import classnames from 'classnames';
import React, { ReactNode } from 'react';
import { Col, ColProps } from 'react-bootstrap';

type Props = {
  title: string;
  children: ReactNode;
  changed?: boolean;
  highlight?: boolean;
  right?: boolean;
  titleClassName?: string;
} & ColProps;

const DisplayDataItem: React.FC<Props> = ({
  title,
  children,
  changed = false,
  highlight = false,
  right = false,
  titleClassName,
  ...props
}) => {
  const classesItem = classnames({
    changed,
    highlight
  });

  return (
    <Col {...props} className={classesItem}>
      <b
        className={classnames('dd-title', titleClassName)}
        data-testid={`ddi_title_${title}`}
      >
        {title}
      </b>
      <div
        className={classnames('dd-content', { right })}
        data-testid="ddi-content"
      >
        {children}
      </div>
    </Col>
  );
};

export default DisplayDataItem;
